import { LoanRefinance } from './loan-refinance.js';
import { CollegeSavings } from './college-savings.js';
import { LoanPayment } from './loan-payment.js';
import {CollegeCosts} from './cost-estimator.js';
import {CompareCosts} from './compare-costs.js';

export default function initCalculators() {
	const loanRefinance = new LoanRefinance();
	loanRefinance.init();

	const collegeSavings = new CollegeSavings();
	collegeSavings.init();

	const loanPayment = new LoanPayment();
	loanPayment.init();

	const collegeCosts = new CollegeCosts();
	collegeCosts.init();

	const compareCosts = new CompareCosts();
	compareCosts.init();

	
	document.querySelectorAll('.calculator-section').forEach(calculator => {
		const selects = calculator.querySelectorAll('select');
		///const slider = calculator.closest('.team-grid-slider');
		if (calculator.closest('.team-grid-slider')){
			selects.forEach(select => {
				select.addEventListener('mousedown', function(e) {
					e.stopPropagation();
				});
			});
		}
	});
	

	//used by multiple calculators to create mobile UI from table
	window.mefaBuildMobileCalcResults = (calculator, dropTitle, filterCol=1) => {
		//remove previous mobile UI
		const results = calculator.querySelector('.results');
		if(results){
			const dLgNone = results.querySelectorAll('.d-lg-none').forEach(el => el.remove());
		}

		const existingRowContainers = calculator.querySelectorAll('.row-container');
		existingRowContainers.forEach(rowContainer => {
			rowContainer.remove();
		});
		const table = calculator.querySelector('.results table');
		const rows = table.rows;
		const resultsContainer = calculator.querySelector('.results');
		// resultsContainer.removeChild(table);
		const firstRow = rows[0];
		const firstRowCells = firstRow.cells;

		const termsSelection = document.createElement('div');
		termsSelection.classList.add('terms-selection');
		// termsSelection.classList.add('d-lg-none');
		const selectLabel = document.createElement('label');
		selectLabel.innerText = dropTitle;
		termsSelection.appendChild(selectLabel);

		const selectEl = document.createElement('select');
		selectEl.classList.add('form-select');
		termsSelection.appendChild(selectEl);
		selectEl.addEventListener('change', (e) => {
			e.preventDefault();
			const value = e.target.value;
			console.log(value, `.results-mobile-item[data-filter="${value}"]`);
			const activeRow = calculator.querySelector(`.results-mobile-item[data-filter="${value}"]`);
			const allRowContainers = calculator.querySelectorAll('.results-mobile-item');
			allRowContainers.forEach(rowContainer => rowContainer.classList.remove('active'));
			if(activeRow) activeRow.classList.add('active');

		});

		const mobileResults = document.createElement('div');
		mobileResults.classList.add('d-lg-none');
		mobileResults.classList.add('results-mobile');
		const mobileInner = document.createElement('div');
		mobileInner.classList.add('results-mobile-inner');
		const mobileContainer = document.createElement('div');
		// mobileContainer.classList.add('row-container');
		mobileContainer.classList.add("results-mobile-container");

		//get the filters from the first column and labels from the first row
		if(filterCol === 1){
			for (let i = 1; i < rows.length; i++) {
				const row = rows[i];
				const cells = row.cells;

				const rowContainer = document.createElement('div');
				rowContainer.classList.add('results-mobile-item');
				if(i === 1){
					rowContainer.classList.add('active');
				}

				for (let j = 0; j < cells.length; j++) {
					const cell = cells[j];
					const firstRowCell = firstRowCells[j];
					const th = firstRowCell?.innerText;
					const td = cell;
					if(j === 0){
						selectEl.add(new Option(td.innerText));
						rowContainer.setAttribute('data-filter', td.innerText);
					}else{
						// if(th === "Year"){
						// 	continue;
						// }
						if(th && td){
							const thContainer = document.createElement('div');
							thContainer.classList.add('title');
							thContainer.innerText = th;
							const tdContainer = document.createElement('div');
							tdContainer.classList.add('value');
							tdContainer.appendChild(td.cloneNode(true));
							rowContainer.appendChild(thContainer);
							rowContainer.appendChild(tdContainer);
							// rowContainer.appendChild(itemContainer);
						}

					}
				}
				mobileContainer.appendChild(rowContainer);
			}
		}

		//get the filters from the first row and labels from the first columns
		if(filterCol === 2){
			let filters = [];
			//get the column / filter values first
			for (let j = 1; j < rows[0].cells.length; j++) {
				selectEl.add(new Option(firstRowCells[j]?.innerText, "filter-"+j));
				filters.push(firstRowCells[j]?.innerText);
			}
			//now do the rows which are really cells
			let count = 0;
			filters.forEach(filter => {
				const rowContainer = document.createElement('div');
				rowContainer.classList.add('results-mobile-item');
				rowContainer.setAttribute('data-filter', "filter-"+(count+1));
				if(count === 0){
					rowContainer.classList.add('active');
				}
				for (let i = 1; i < rows.length; i++) {
					const row = rows[i];
					const cells = row.cells;
					const thContainer = document.createElement('div');
					thContainer.classList.add('title');
					thContainer.innerText = cells[0]?.innerText;
					rowContainer.appendChild(thContainer);

					const tdContainer = document.createElement('div');
					tdContainer.classList.add('value');
					tdContainer.innerText = cells[(count+1)]?.innerText;
					rowContainer.appendChild(tdContainer);

				}
				mobileContainer.appendChild(rowContainer);
				count++;
			});
		}

		mobileInner.appendChild(termsSelection);
		mobileInner.appendChild(mobileContainer);
		mobileResults.appendChild(mobileInner);

		resultsContainer.appendChild(mobileResults);
	}

	document.querySelectorAll('.calculator-section.type-interest_rates').forEach(calculator => {
		window.mefaBuildMobileCalcResults(calculator, 'Repayment Terms', 2);
	})
}
